import React from 'react';
import propTypes from 'prop-types';
import FeaturedVideo from '../Shared/FeaturedVideo/FeaturedVideo';

const Video = ({videoUrl, elClass, imgUrl, text}) => {
	return (
		<div className={`${elClass} ${elClass}__container featured-video main-grid`}>
			<div className='main-grid__margin'></div>
			<div>
				<div className='main-grid__body featured-video__wrapper'>
					<div className='featured-video__container'>
						<FeaturedVideo 
							videoUrl={videoUrl}
							imageUrl={imgUrl}
						/>
					</div>
				</div>
				<div className={`${elClass}__text img-caption`} dangerouslySetInnerHTML={{__html: text}}></div>
			</div>
			<div className='main-grid__margin'></div>
		</div>
	)
}

export default Video;

Video.propTypes = {
	videoUrl: propTypes.string.isRequired,
	elClass: propTypes.string.isRequired,
	imgUrl: propTypes.string,
	text: propTypes.string
}